module.exports = __webpack_public_path__ + "img/step-one-img.f430684.svg";